export type DiffPayload = {
  sceneId: string;
  hasDraft: boolean;
  items: {
    added: { id: string; english: string }[];
    removed: { id: string; english: string }[];
    changed: { id: string; english: string; polygonChanged: boolean; englishChanged: boolean }[];
  };
  translations: {
    added: { itemId: string; lang: string }[];
    removed: { itemId: string; lang: string }[];
    changed: { itemId: string; lang: string }[];
  };
};

export function diffIsEmpty(diff: DiffPayload): boolean {
  return (
    diff.items.added.length === 0 &&
    diff.items.removed.length === 0 &&
    diff.items.changed.length === 0 &&
    diff.translations.added.length === 0 &&
    diff.translations.removed.length === 0 &&
    diff.translations.changed.length === 0
  );
}
